import { initRatingForm } from "Functions/rating";
import { initQuestionForm } from "Functions/question";
import { initPriceForm } from "Functions/price";
import { Vue, i18n } from "Common/vue";
import ShippingInfo from "VueComponents/ShippingInfo.vue";
import Ratings from "VueComponents/Ratings.vue";
import { initAnchors } from "Functions/anchor";
import tippy from "tippy.js";

import initializeVueProductVariations from "Components/vue/productVariations/utils/initializeVueProductVariations";
import { initializeVariationsDynamicElements } from "Components/vue/productVariations/utils/variationsDynamicElements";

import "Layouts/default";

import "Ui/slider";
import "Ui/toggle";
import "Ui/more-items";
import "Ui/star-rating";
import "Ui/collapsible-content";

import "Common/social";
import "Common/lightgallery";
import "Common/wishlist";

import "Components/modal/modal-remote";
import "Components/modal/modal-watchdog";

import "./product-jquery";

initRatingForm();
initAnchors();
initQuestionForm();
initPriceForm();

if (document.querySelector(".js-ratings-box")) {
    window.$_ratings = new Vue({
        i18n,
        render: (h) => h(Ratings),
    }).$mount(".js-ratings-box");

    document.querySelectorAll(".js-trigger-rating-filter").forEach((trigger) => {
        trigger.addEventListener("click", (event) => {
            const starsNumber = trigger.dataset.starsNumber;
            const ratingsCount = trigger.dataset.ratingsCount;

            rEvent.dispatch("Rating.triggerFilter", starsNumber, ratingsCount);
        });
    });
}

document.querySelectorAll('[data-has-component="shippingInfo"]').forEach((element) => {
    new Vue({
        el: element,
        components: {
            ShippingInfo,
        },
    });

    element.removeAttribute("data-has-component");
});

$(function () {
    tippy(".js-tippy-custom", {
        arrow: true,
        interactive: true,
        trigger: "manual",
        content: document.querySelector("#price-request-tippy-content").innerHTML,
        allowHTML: true,
    });

    $(".js-share-current-url").on("click", async function () {
        const shareData = {
            title: document.querySelector('meta[property="og:title"]').content,
            url: window.location.href,
        };

        try {
            await navigator.share(shareData);
        } catch (err) {
            if (err && err.name === "AbortError") {
                return;
            }

            try {
                // copy url to clipboard if share is not supported
                await navigator.clipboard.writeText(shareData.url);

                Eshop.alert($(this).data("success"));
            } catch (err) {
                Eshop.alert($(this).data("error"), { type: "error" });
            }
        }
    });

    $(".js-price-request-form").validate({
        submitHandler: function (form) {
            $(".js-price-request-submit").prop("disabled", true).addClass("is-loading");
            $(".js-price-request-error").slideUp(150);

            window.assignRecaptchaResponseToForm(form).then(function () {
                Form.ajaxPost(
                    form,
                    function (data) {
                        $(".js-price-request-submit")
                            .prop("disabled", false)
                            .removeClass("is-loading");

                        if (data.status) {
                            $(".js-price-request-hide").slideUp(250);
                            $(".js-price-request-success").slideDown(250);
                        } else {
                            $(".js-price-request-error").html(data.message).slideDown(250);
                        }
                    },
                    "json"
                );
            });
        },
    });
});

function checkSelectionForPriceRequest(event) {
    const selection = document.getSelection();

    if (selection.anchorNode == null || selection.focusNode == null) {
        return;
    }

    const anchorNode = selection.anchorNode.parentElement;
    const focusNode = selection.focusNode.parentElement;
    const isHighlighted =
        anchorNode.classList.contains("js-tippy-custom") &&
        focusNode.classList.contains("js-tippy-custom");

    if (isHighlighted && !selection.isCollapsed) {
        if (event.target._tippy && !event.target._tippy.state.visible) {
            setTimeout(function () {
                event.target._tippy.show();
            }, 0);
        }
    }
}

document.addEventListener("mouseup", checkSelectionForPriceRequest);
document.addEventListener("touchend", checkSelectionForPriceRequest);

initializeVueProductVariations();

document.addEventListener("DOMContentLoaded", () => {
    initializeVariationsDynamicElements();
});
